import { render, staticRenderFns } from "./UnassignedTripChart.vue?vue&type=template&id=4545d559&"
import script from "./UnassignedTripChart.vue?vue&type=script&lang=js&"
export * from "./UnassignedTripChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports